<template>
  <div class="page-dashboard">
    <el-tabs v-model="activeTab">
      <!-- BRAND TAB -->
      <el-tab-pane label="Brand" name="Brand" v-loading="brandDataLoading">
        <div v-if="hasBrandData">
          <div class="flex items-center mb-20">
            <h2 class="mb-0 mt-0 mr-10 text-left">Brand Status</h2>
            <div>
              <el-tag
                v-if="
                  !['VETTED_VERIFIED', 'VERIFIED'].includes(
                    brandData.identityStatus
                  )
                "
              >
                <el-popover
                  trigger="hover"
                  width="300px"
                  placement="bottom-start"
                >
                  <i
                    class="el-icon-info"
                    style="margin-right: 4px"
                    slot="reference"
                  ></i>
                  <h2 class="form-section-header">
                    Brand Feedback: {{ brandFeedback.brandId }}
                  </h2>

                  <div
                    v-for="categoryItem in brandFeedback.category"
                    :key="categoryItem.id"
                  >
                    <h2>{{ categoryItem.displayName }}</h2>
                    <p>{{ categoryItem.description }}</p>
                    <ul>
                      <li v-for="field in categoryItem.fields">{{ field }}</li>
                    </ul>
                  </div>
                </el-popover>
                {{ brandData.identityStatus }}
              </el-tag>
              <el-tag
                v-else
                style="background-color: rgba(0, 255, 0, 0.1); color: #13ce66"
              >
                {{ brandData.identityStatus }}
              </el-tag>
            </div>
            <div
              v-if="
                ['UNVERIFIED'].includes(brandData.identityStatus) &&
                brandData.entityType === 'PUBLIC_PROFIT'
              "
              class="box right"
            >
              <el-button @click="resend2faEmail" v-if="selectedTenant.brandId"
                >Resend 2FA Email</el-button
              >
            </div>
          </div>

          <el-row
            class="mt-0"
            :gutter="30"
            style="padding-right: 2px; padding-left: 2px"
          >
            <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
              <div
                class="card-base card-shadow--medium mb-30 widget-md small-widget"
                style="height: 400px"
              >
                <div class="widget-header ph-20 pt-10">
                  <div class="flex justify-center align-center">
                    <div class="widget-info box grow text-truncate">
                      <h2
                        class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center"
                      >
                        <v-svg class="voxo-red pr-10" sprite="lighthouse" />
                        Brand Details
                      </h2>
                    </div>
                  </div>
                  <div v-if="brandData.brandId" class="text-truncate">
                    <div class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Brand Id</span>
                        {{ brandData.brandId }}
                      </div>
                    </div>
                    <div v-if="brandData.companyName" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Name</span>
                        {{ brandData.companyName }}
                      </div>
                    </div>
                    <div v-if="brandData.entityType" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Entity Type</span>
                        {{ brandData.entityType }}
                      </div>
                    </div>
                    <div v-if="brandData.ein" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Ein</span>
                        {{ brandData.ein }}
                      </div>
                    </div>
                    <div v-if="brandData.email" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Support Email</span>
                        {{ brandData.email }}
                      </div>
                    </div>
                    <div v-if="brandData.createDate" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Registered On</span>
                        {{ timeFormatter(brandData.createDate) }}
                      </div>
                    </div>
                    <div v-if="brandData.website" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Website</span>
                        {{ brandData.website }}
                      </div>
                    </div>
                    <div v-if="fullAddress" class="status-wrapper">
                      <div class="system-status-group">
                        <span class="black-text">Address</span>
                        {{ fullAddress }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>

            <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8">
              <div
                class="card-base card-shadow--medium mb-30 widget small-widget"
                style="height: 400px"
              >
                <div class="widget-header ph-20 pt-10">
                  <div class="flex justify-center align-center">
                    <div class="widget-info box grow text-truncate">
                      <h2
                        class="m-10 widget-title text-truncate pt-5 pb-10 flex align-center"
                      >
                        <v-svg
                          class="voxo-yellow pr-10"
                          sprite="list-numbers"
                        />
                        Campaigns
                      </h2>
                      <h1 class="text-truncate voxo-yellow text-center">
                        {{ total }}
                      </h1>
                      <h4 class="black-text text-center">Registered</h4>
                      <div class="dashboard-button">
                        <el-button @click="activeTab = 'Campaigns'">
                          <div class="dashboard-button-group">
                            <span>View All Campaigns</span>
                          </div>
                        </el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

        <div v-else>
          <p>
            Your account is not linked with any brand currently. Please get in
            touch with customer service for additional help.
          </p>
        </div>
      </el-tab-pane>

      <!-- CAMPAIGNS TAB -->
      <el-tab-pane
        label="Campaigns"
        name="Campaigns"
        v-loading="campaignDataLoading"
      >
        <div class="page-table scrollable only-y">
          <div class="no-table-box page-header">
            <div class="flex pb-20">
              <div class="box">
                <el-input v-model="search" placeholder="Search" clearable>
                </el-input>
                <el-button class="ml-10 hidden-xs-only" @click="doExport">
                  Export
                </el-button>
              </div>
              <div class="box right">
                <el-button
                  @click="showModal('Create')"
                  v-if="selectedTenant.brandId"
                  >Add New</el-button
                >
              </div>
            </div>
            <div class="vxe-table-height card-base card-shadow--medium">
              <vxe-grid
                round
                border="inner"
                ref="xGrid"
                height="100%"
                auto-resize
                empty-text="No Data"
                stripe
                highlight-hover-row
                show-overflow="tooltip"
                @cell-click="cellClicked"
                @cell-mouseenter="rowHover"
                @cell-mouseleave="rowLeave"
                :data="tableData"
                :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
                :sort-config="{
                  defaultSort: { field: 'campaignStartDate', order: 'desc' },
                }"
                :loading="tableLoading"
                :columns="tableColumns"
              />
            </div>
          </div>

          <!-- FORM COMPONENT -->
          <campaign-form
            :visible="modalVisible"
            :context="modalContext"
            :recordId="modalModelId"
            :email="brandEmail"
            @modalClosed="handleModalClose"
          />

          <campaign-phone-numbers
            :recordId="campaignId"
            :visible="phoneNumbersVisible"
            @modalClosed="handlePhoneNumbersModalClose"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import moment from "moment-timezone";
import campaignForm from "./components/form.vue";
import { globalEventBus } from "@/globalEventBus";
import feathersClient from "../../../feathers/feathers-client";
import debounce from "lodash/debounce";
import { ExportToCsv } from "export-to-csv";
import { apiV2Host } from "@/feathers/feathers-client";
import DadsSelect from "@/components/select";
import campaignPhoneNumbers from "@/views/pages/10dlc/components/campaign-phone-numbers.vue";

export default {
  name: "UsersTable",
  components: { campaignPhoneNumbers, DadsSelect, campaignForm },
  data() {
    return {
      activeTab: "Brand",
      brandDataLoading: false,
      campaignDataLoading: false,
      brandData: {},
      brandFeedback: {
        brandId: "string",
        category: [
          {
            id: "string",
            displayName: "string",
            description: "string",
            fields: ["string"],
          },
        ],
      },
      brandEmail: "",
      eventChannel: null,
      tableData: [],
      allCampaigns: [],
      tableLoading: false,
      search: "",
      visibleActionsId: "",
      modalModelId: "",
      modalContext: "",
      modalVisible: false,
      phoneNumbersVisible: false,
      campaignId: null,
      brandFeedbackVisible: false,
      total: 0,
      tableColumns: [
        {
          field: "sprite",
          title: "",
          width: 50,
          slots: {
            default: ({ row }) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="white" sprite="message" />
                </div>,
              ];
            },
          },
        },
        {
          field: "campaignId",
          title: "Campaign Id",
          sortable: false,
          showOverflow: false,
          width: 150,
        },
        {
          field: "brandId",
          title: "Brand Id",
          sortable: false,
          minWidth: 150,
          showOverflow: false,
        },
        {
          field: "brandName",
          title: "Brand Name",
          sortable: true,
          minWidth: 200,
          showOverflow: "tooltip",
          slots: {
            default: ({ row }) => {
              return [<span>{row.brandName ? row.brandName : "N/A"}</span>];
            },
          },
        },
        {
          field: "tnAssignedCount",
          title: "Assigned Number Count",
          sortable: true,
          minWidth: 200,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <span>
                  {row.tnAssignedCount !== undefined
                    ? row.tnAssignedCount === 0
                      ? 0
                      : row.tnAssignedCount
                    : "N/A"}
                </span>,
              ];
            },
          },
        },
        {
          field: "campaignStartDate",
          title: "Start Date",
          sortable: true,
          minWidth: 150,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <span>
                  {row.campaignStartDate
                    ? moment(row.campaignStartDate).format("M/DD/YY")
                    : "N/A"}
                </span>,
              ];
            },
          },
        },
        {
          field: "isDcaApproved",
          title: "DCA Approved",
          sortable: false,
          minWidth: 150,
          showOverflow: "tooltip",
          slots: {
            default: ({ row }) => {
              return [
                <span>
                  {row.isDcaApproved === "Y" ? "Approved" : "Not Approved"}
                </span>,
              ];
            },
          },
        },
        {
          field: "status",
          title: "TCR Status",
          sortable: true,
          minWidth: 150,
          showOverflow: "tooltip",
          slots: {
            default: ({ row }) => {
              return [<span>{this.capitalizeFirstLetter(row.status)}</span>];
            },
          },
        },
        {
          field: "actions",
          title: "",
          minWidth: 200,
          showOverflow: false,
          slots: {
            default: ({ row }) => {
              return [
                <div
                  v-show={
                    row.campaignId === this.visibleActionsId &&
                    row.status !== "EXPIRED"
                  }
                >
                  <el-tooltip placement="top" content="Edit">
                    <el-button
                      id={"edit-" + row.id}
                      icon="el-icon-edit"
                      onClick={() => this.showModal("Edit", row.campaignId)}
                      class="table-action-button icon-blue"
                    />
                  </el-tooltip>

                  <el-tooltip placement="top" content="Delete">
                    <el-button
                      id={"delete-" + row.id}
                      icon="el-icon-delete"
                      onClick={() => this.deleteRecord(row.campaignId)}
                      class="table-action-button icon-red"
                    />
                  </el-tooltip>

                  <el-tooltip placement="top" content="View Numbers">
                    <el-button
                      onClick={() => this.showPhoneNumbersModal(row.campaignId)}
                      class="table-action-button icon-white"
                    >
                      <i class="mdi mdi-format-list-bulleted" />
                    </el-button>
                  </el-tooltip>
                </div>,
              ];
            },
          },
        },
      ],
    };
  },
  computed: {
    user() {
      return this.$store.state.auth.user;
    },
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    hasBrandData() {
      return Object.keys(this.brandData).length > 0;
    },
    fullAddress() {
      if (Object.keys(this.brandData).length === 0) return;
      return `${this.brandData.street} ${this.brandData.city}, ${this.brandData.state} ${this.brandData.postalCode} ${this.brandData.country}`;
    },
  },
  watch: {
    user() {
      if (!this.eventChannel) {
        this.joinSocketChannel();
      }
    },
    search: debounce(function () {
      this.searchCampaigns();
    }, 500),
    selectedTenant() {
      this.clearData();
      this.queryBrand();
      this.queryCampaigns();
    },
    async hasBrandData() {
      if (
        this.hasBrandData &&
        !["VETTED_VERIFIED", "VERIFIED"].includes(this.brandData.identityStatus)
      ) {
        await this.getBrandFeedback();
      }
    },
  },
  methods: {
    async getBrandFeedback() {
      const { brandId } = this.selectedTenant;

      try {
        const res = await fetch(`${apiV2Host}/admin/tcr/brands/feedback/${brandId}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken,
          },
        });

        if (!res.ok) {
          throw new Error("There was an error retrieving your brand data!");
        }

        this.brandFeedback = await res.json();

        this.brandFeedbackVisible = true;
      } finally {
        this.brandDataLoading = false;
      }
    },
    capitalizeFirstLetter(str) {
      if (!str || typeof str !== "string") {
        return str;
      }
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    },
    searchCampaigns() {
      if (this.search.length) {
        this.tableData = this.allCampaigns.filter(
          (data) =>
            data.campaignClassName
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.externalCampaignId
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.messagingBrandId
              .toLowerCase()
              .includes(this.search.toLowerCase()) ||
            data.messagingBrandName
              .toLowerCase()
              .includes(this.search.toLowerCase())
        );
      } else {
        this.tableData = [...this.allCampaigns];
      }
      this.total = this.tableData.length;
    },

    roleTitle(val) {
      if (+val === 1) return "Platform Admin";
      if (+val === 3) return "Account Admin";
      if (+val === 5) return "User";
      if (+val === 7) return "Queue Manager";
      if (+val === 9) return "Reports Admin";
      if (+val === 11) return "Partner Admin";
      if (+val === 12) return "Pharmacy Owner";
      if (+val === 13) return "Pharmacy Admin";
      if (+val === 14) return "Pharmacy User";
      return "No Role";
    },

    showModal(context, editId) {
      this.modalVisible = true;
      this.modalContext = context;
      this.modalModelId = editId;
    },

    showPhoneNumbersModal(editId) {
      this.phoneNumbersVisible = true;
      this.campaignId = editId;
    },

    //General Form and Table Operations
    cellClicked(data) {
      if (data.column.property !== "actions") {
        if (data.row.status === "EXPIRED") return;
        this.showModal("Edit", data.row.campaignId);
      }
    },
    rowHover(data) {
      this.visibleActionsId = data.row.campaignId;
    },
    rowLeave() {
      this.visibleActionsId = "";
    },
    async deleteRecord(campaignId) {
      try {
        await this.$confirm("Permanently delete this campaign?", "Warning", {
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        });
      } catch (e) {
        return;
      }
      try {
        const response = await fetch(
          `${apiV2Host}/admin/tcr/campaigns/${campaignId}`,
          {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("There was an issue deleting this campaign!");
        }

        await this.queryCampaigns();
      } catch (error) {
        this.$notify({
          title: "Updating Form data",
          message: error,
          type: "error",
        });
      }
    },

    removeListeners() {
      globalEventBus.$off("appReconnected");
    },

    handleModalClose() {
      this.modalVisible = false;
      this.modalContext = "";

      // refresh the campaign list
      this.queryCampaigns();
    },

    handlePhoneNumbersModalClose() {
      this.phoneNumbersVisible = false;
      this.campaignId = null;
    },

    handleCloseModal() {
      this.brandFeedbackVisible = false;
    },

    joinSocketChannel() {
      const channelService = feathersClient.service("channel-memberships");
      const data = {
        roomType: "admins/users",
      };
      channelService.create(data).then((res) => {
        this.eventChannel = `${data.roomType}`;
      });
    },

    doExport() {
      const data = [...this.tableData];
      if (data.length) {
        const writeData = data.map((item) => ({
          externalCampaignId: item.externalCampaignId,
          campaignClassName: item.campaignClassName,
          messagingBrandId: item.messagingBrandId,
          messagingBrandName: item.messagingBrandName,
          tnAssignedCount: item.tnAssignedCount,
          campaignStartDate: item.campaignStartDate,
          isDcaApproved: item.isDcaApproved,
        }));

        const options = {
          filename: "campaigns",
          showLabels: true,
          headers: [
            "Campaign Id",
            "Campaign Class Name",
            "Brand Id",
            "Brand Name",
            "Assigned Number Count",
            "Start Date",
            "DCA Approved",
          ],
        };

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },
    async queryBrand() {
      this.brandDataLoading = true;
      const { brandId } = this.selectedTenant;

      if (!brandId) {
        this.brandDataLoading = false;
        return;
      }

      try {
        const res = await fetch(`${apiV2Host}/admin/tcr/brands/${brandId}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken,
          },
        });

        if (!res.ok) {
          throw new Error("There was an error retrieving your brand data!");
        }

        this.brandData = await res.json();

        if (this.brandData && this.brandData.identityStatus !== "VERIFIED") {
          await this.getBrandFeedback();
        }
      } catch (e) {
        this.$notify({
          title: "Retrieving Form data",
          message: e,
          type: "error",
        });
      } finally {
        this.brandDataLoading = false;
      }
    },
    async queryCampaigns() {
      this.campaignDataLoading = true;
      const { id, brandId } = this.selectedTenant;

      if (!brandId) {
        this.campaignDataLoading = false;
        return;
      }

      try {

        const campaignData = await fetch(`${apiV2Host}/admin/tcr/campaigns?tenantId=${id}`, {
          method: "GET",
          headers: {
            Authorization: "Bearer " + this.$store.state.auth.accessToken,
          },
        });

        if (!campaignData.ok) {
          throw new Error("There was an error retrieving your Table data!");
        }

        this.tableData = await campaignData.json();
        this.allCampaigns = this.tableData;
        this.total = this.tableData.length;
      } catch (e) {
        this.$notify({
          title: "Retrieving Form data",
          message: e,
          type: "error",
        });
      } finally {
        this.campaignDataLoading = false;
      }
    },
    async resend2faEmail() {
      const { brandId } = this.selectedTenant;

      if (!brandId) {
        this.campaignDataLoading = false;
        return;
      }

      try {
        const response = await fetch(
          `${apiV2Host}/tcr/brands/${brandId}/resend-2fa-email`,
          {
            method: "POST",
            headers: {
              Authorization: "Bearer " + this.$store.state.auth.accessToken,
            },
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    clearData() {
      this.brandData = {};
      this.brandFeedback = {
        brandId: "string",
        category: [
          {
            id: "string",
            displayName: "string",
            description: "string",
            fields: ["string"],
          },
        ],
      };
      this.brandEmail = "";
      this.tableData = [];
      this.allCampaigns = [];
      this.tableLoading = false;
      this.search = "";
      this.visibleActionsId = "";
      this.modalModelId = "";
      this.modalContext = "";
      this.modalVisible = false;
      this.brandFeedbackVisible = false;
      this.total = 0;
    },
    timeFormatter(time) {
      return moment(time).format("M/DD/YY");
    },
  },
  mounted() {
    if (this.user) {
      this.queryBrand();
      this.queryCampaigns();
    }
  },
  created() {
    //rejoin channel on reconnect
    globalEventBus.$on("appReconnected", () => {
      this.joinSocketChannel();
    });
  },
  beforeDestroy() {
    feathersClient
      .service("channel-memberships")
      .remove(null, { query: { channelName: this.eventChannel } });
    this.removeListeners();
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/variables";

.page-dashboard {
  overflow: auto;

  .card-base {
    h1 {
      font-weight: 900;
    }

    h2 {
      svg {
        width: 25px;
        height: 25px;
        padding-right: 6px;
      }
    }
  }
}

.widget-info {
  h1,
  h4 {
    margin: 0px;
  }

  h1 {
    font-size: 3em;
  }
}

.dashboard-button-group {
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    padding-left: 10px;
  }
}

.dashboard-button {
  text-align: center;
  padding: 18px;
}

.system-status {
  display: flex;
  flex-wrap: wrap;

  > * {
    flex-basis: 50%;
  }
}

.system-status-group {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 7px;
  padding-bottom: 3px;
  border-bottom: 1px solid lightgray;
}

.widget {
  height: 250px;
  position: relative;

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      width: 60px;
      padding: 5px;
    }

    .widget-title {
      font-weight: 700;
      border-bottom: 1px solid lightgrey;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}

.widget-sm {
  height: 200px;
  position: relative;

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      width: 60px;
      padding: 5px;
    }

    .widget-title {
      font-weight: 700;
      border-bottom: 1px solid lightgrey;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}

.widget-md {
  height: 320px;
  position: relative;

  .widget-header {
    .widget-icon-box {
      background: rgba(0, 0, 0, 0.02);
      border: 1px solid rgba(0, 0, 0, 0.02);
      border-radius: 4px;
      text-align: center;
      width: 60px;
      padding: 5px;
    }

    .widget-title {
      font-weight: 700;
      border-bottom: 1px solid lightgrey;
    }
  }

  .badge-box {
    .badge {
      display: inline-block;
      border-radius: 4px;
      font-size: 80%;
    }
  }
}

.timeline {
  max-width: 1200px;
  margin: 6px;
}

.timeline,
.timeline-title {
  color: $text-color;
  line-height: 1.4;
  cursor: default;
  font-family: inherit;
}

@media (min-width: 768px) and (max-width: 1040px) {
  .radio-switcher {
    display: none;
  }

  .widget {
    .widget-header {
      .widget-icon-box {
        display: none;
      }
    }
  }
}

@media (max-width: 420px) {
  .radio-switcher {
    display: none;
  }
}
</style>

<style lang="scss">
.page-dashboard {
  .widget {
    .peity {
      position: absolute;
      bottom: -1px;
      left: 0;
      border-bottom-left-radius: 5px;
      border-bottom-right-radius: 5px;
    }
  }

  table.styled {
    .peity {
      margin-right: 10px;
    }
  }

  .vb-content {
    padding: 0 20px;
    box-sizing: border-box !important;
    margin-top: -5px;
    margin-left: -20px;
    margin-right: -20px;
    height: calc(100% + 15px) !important;
    width: calc(100% + 40px) !important;
  }
}

@media (max-width: 768px) {
  .page-dashboard {
    .vb-content {
      padding: 0 5px !important;
      margin: -5px;
      width: calc(100% + 10px) !important;
    }
  }
}
</style>
